import { render, staticRenderFns } from "./deviceDetail.vue?vue&type=template&id=386a4068&scoped=true&"
import script from "./deviceDetail.vue?vue&type=script&lang=js&"
export * from "./deviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./deviceDetail.vue?vue&type=style&index=0&id=386a4068&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a4068",
  null
  
)

export default component.exports